import React, { useState } from 'react';
import {
    Box,
    IconButton,
    Card,
    CardMedia,
    CardContent,
    Typography,
    CardActions,
    Button,
    useMediaQuery,
    useTheme,
    Fade,
    Tooltip
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ScrollableCardRow = ({ cards, startIndex, setStartIndex }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const visibleCount = isMobile ? 1 : 4;

    const handlePrev = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };

    const handleNext = () => {
        if (startIndex < cards.length - visibleCount) {
            setStartIndex(startIndex + 1);
        }
    };

    const showPrev = startIndex > 0;
    const showNext = startIndex < cards.length - visibleCount;

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
                width: '100%',
                mt: 1,
                mb: 6,
                flexDirection: isMobile ? 'column' : 'row',
                mr: isMobile ? 0 : 2,
            }}
        >
            {isMobile && (
                <Box
                    display="flex"
                    width="100%"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <IconButton
                            onClick={handlePrev}
                            disabled={!showPrev}
                            sx={{
                                opacity: showPrev ? 1 : 0.3,
                                transition: 'opacity 0.3s',
                            }}
                        >
                            <ArrowBackIosIcon />
                        </IconButton>

                        <Typography
                            variant="caption"
                            noWrap
                            sx={{
                                maxWidth: 50,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                opacity: showPrev ? 1 : 0.3,
                                transition: 'opacity 0.3s',
                            }}
                        >
                            Atrás
                        </Typography>
                    </Box>

                    <Box display="flex" flexDirection="column" alignItems="center">
                        <IconButton
                            onClick={handleNext}
                            disabled={!showNext}
                            sx={{
                                opacity: showNext ? 1 : 0.3,
                                transition: 'opacity 0.3s',
                            }}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>

                        <Typography
                            variant="caption"
                            noWrap
                            sx={{
                                maxWidth: 50,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                opacity: showNext ? 1 : 0.3,
                                transition: 'opacity 0.3s',
                            }}
                        >
                            Ver Más
                        </Typography>
                    </Box>
                </Box>
            )}

            {!isMobile && (
                <Tooltip title="Atrás" arrow placement="top">
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <IconButton
                            onClick={handlePrev}
                            disabled={!showPrev}
                            sx={{
                                opacity: showPrev ? 1 : 0.3,
                                transition: 'opacity 0.3s',
                            }}
                        >
                            <ArrowBackIosIcon />
                        </IconButton>
                    </Box>
                </Tooltip>
            )}


            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    maxWidth: '1300px',
                    justifyContent: 'center',
                }}
            >
                {cards.slice(startIndex, startIndex + visibleCount).map((card) => (
                    <Box
                        key={card.id}
                        sx={{
                            flex: isMobile ? '0 0 100%' : `0 0 ${100 / visibleCount}%`,
                            px: isMobile ? 0 : 1,
                            maxWidth: isMobile ? '400px' : 'none',
                        }}
                    >
                        <Card
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                mx: 'auto',
                            }}
                        >
                            <CardMedia
                                component="img"
                                height={isMobile ? "280" : "250"}
                                image={card.image}
                                alt={card.title}
                                sx={{
                                    objectFit: 'cover'
                                }}
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h6">
                                    {card.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" textAlign="justify">
                                    {card.description}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{ justifyContent: 'center', mt: 'auto' }}>
                                <Button
                                    size="small"
                                    sx={{
                                        color: 'var(--color-white)',
                                        backgroundColor: 'var(--color-brand-primary)',
                                        '&:hover': {
                                            borderColor: 'var(--color-white)',
                                            backgroundColor: 'var(--color-brand-secondary)',
                                            color: 'var(--color-white)',
                                        },
                                    }}
                                    onClick={card.action}
                                >
                                    {card.buttonText}
                                </Button>
                            </CardActions>
                        </Card>
                    </Box>
                ))}
            </Box>

            {!isMobile && (
                <Tooltip title="Ver Más" arrow placement="top">
                    <Box display="flex" flexDirection="column" alignItems="center" ml={1} mr={3}>
                        <IconButton
                            onClick={handleNext}
                            disabled={!showNext}
                            sx={{
                                opacity: showNext ? 1 : 0.3,
                                transition: 'opacity 0.3s',
                            }}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </Box>
                </Tooltip>

            )}

        </Box>
    );
};

export default ScrollableCardRow;
